import { uploadBtsFileSaga } from './uploadBtsFile'
import { getBtsDataSaga } from './getBtsData'

const DonneesBtsFileSagas = [uploadBtsFileSaga, getBtsDataSaga]

export default DonneesBtsFileSagas
